<template>
  <div class="preview" ref="preview" v-show="previewShow">
      
      <!-- <button class="closeBtn" @click="closePreview">false</button> -->
      <el-button type="danger" class="closeBtn" icon="el-icon-close" @click="closePreview" circle></el-button>
      <div v-show="displayJson.header && displayJson.header.enable" class="layoutHeader">header</div>
      <div class="content" :style="{height:contentH()+'px'}">
        <grid-layout
                :layout="layout"
                :col-num="colNum"
                :row-height="gridHeight"
                :maxRows="rowNum"
                :is-draggable="false"
                :is-resizable="false"
                :is-mirrored="false"
                :vertical-compact="true"
                :margin="gridMargin"
                :use-css-transforms="true"
        >
    
            <grid-item v-for="item in layout" :key="item.i"
                    :x="item.x"
                    :y="item.y"
                    :w="item.w"
                    :h="item.h"
                    :i="item.i"
              >
              <span>{{item.i}}</span>

            </grid-item>
        </grid-layout>
      </div>
      <div v-show="displayJson.footer && displayJson.footer.enable" class="layoutFooter">footer</div>
  </div>
</template>

<script>
export default {
  name: "previewPage",
  props: {
    msg: String,
    previewShow: Boolean,
    closePreview: Function,
    displayJson: Object
  },
  data :function(){
      console.log('type',typeof(this.displayJson),this.displayJson)
    //   colNum = (this.displayJson.option && this.displayJson.option.colNum)?this.displayJson.option.colNum:0;
    //   rowNum = (this.displayJson.option && this.displayJson.option.rowNum)?this.displayJson.option.rowNum:0;
    //   gridHeight = (this.displayJson.option && this.displayJson.option.gridHeight)?this.displayJson.option.gridHeight:0;
      return {
      }
  },
  computed: {
        layout: function () {
          if(this.displayJson.layout){
            return this.displayJson.layout
          } else {
            return []
          }
        },
        colNum: function () {
          if((this.displayJson.option && this.displayJson.option.colNum)){
            return this.displayJson.option.colNum
          } else {
            return 3
          }
        },
        rowNum: function () {
          if((this.displayJson.option && this.displayJson.option.rowNum)){
            return this.displayJson.option.rowNum
          } else {
            return 2
          }
        },
        gridHeight: function () {
          
          var h = this.windowH();
          // if(this.$refs['preview']){
          //   h = this.$refs['preview'].clientHeight;
          // }
          if(this.displayJson.header && this.displayJson.header.enable){
            h -= 55;
          }
          if(this.displayJson.footer && this.displayJson.footer.enable){
            h -= 55;
          }
          console.log('preview',this.$refs['preview'])
          if(this.displayJson.option && this.displayJson.option.rowNum){
            h = h - 10*(this.displayJson.option.rowNum+1);
            h = Math.round(h / this.displayJson.option.rowNum);
          }

          // this.rowNum
          if((this.displayJson.option && this.displayJson.option.gridHeight)){
            return h
          } else {
            return h
          }
        },
        gridMargin: function () {
            return [10,10]
        }
    },
    methods:{
      windowH: function(){
        var w = window,
          d = document,
          e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          // x = w.innerWidth || e.clientWidth || g.clientWidth,
          y = w.innerHeight|| e.clientHeight|| g.clientHeight;
          return y;
      },
      contentH : function(){
        var h = this.windowH();
          // if(this.$refs['preview']){
          //   h = this.$refs['preview'].clientHeight;
          // }
          if(this.displayJson.header && this.displayJson.header.enable){
            h -= 55;
          }
          if(this.displayJson.footer && this.displayJson.footer.enable){
            h -= 55;
          }
        return h
      }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '~@/style/global-variables';
.preview {
  z-index: 100;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ffffff;
  top: 0px;
    .vue-grid-layout{

    }
    .layoutHeader{
      min-height:55px; 
      line-height:55px; 
      background:#C7C7C7;
    }
    .layoutFooter{
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 100%;
      min-height:55px;
      line-height:55px; 
      background:#C7C7C7;
    }
    .content{
      .vue-grid-item{
        border: 1px solid $glb-border-color;
        border-radius:5px;
        background: #FFFFFF;
        // -moz-box-shadow:4px 4px 3px rgba(20%,20%,40%,0.5);
        // -webkit-box-shadow:4px 4px 3px rgba(20%,20%,40%,0.5);
        // box-shadow:4px 4px 3px rgba(20%,20%,40%,0.5);
        overflow: auto;
      }
    }
}
.closeBtn {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 100;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
